<template>
  <div class="renewal">
    <div class="counts">
      <el-radio-group
        v-model="myradio"
        size="mini"
      >
        <el-radio-button label="充值"></el-radio-button>
        <el-radio-button label="赠送"></el-radio-button>
      </el-radio-group>
    </div>
    <div class="renewal__header">
      用户：
      <UserSelect
        v-model="searchValue"
        style="margin-right:20px;width: 180px;min-width:150px"
      />
      <template v-if="myradio === '充值'">
        充值设备数：
        <span>
          <el-input-number
            placeholder="设备数"
            v-model="cars"
            controls-position="right"
            :min="0"
            :max="999999"
            size="small"
            style="margin-right:20px;width: 120px"
          ></el-input-number>
        </span>
        单价（元）：
        <span>
          <el-input-number
            placeholder="单价"
            v-model="coins"
            controls-position="right"
            :min="0"
            :max="999999"
            size="small"
            style="margin-right:20px;width: 120px"
          ></el-input-number>
        </span>
        续费周期（年）：
        <span>
          <el-input-number
            placeholder="周期"
            v-model="years"
            controls-position="right"
            :min="0"
            :max="999999"
            size="small"
            style="margin-right:20px;width: 120px"
          ></el-input-number>
          验证码：
          <span>
            <el-input
              size="small"
              v-model="mycode"
              placeholder="请输入验证码"
              style="margin-right:20px;width: 120px"
            ></el-input>
          </span>
          <identify
            :identifyCode.sync="identifyCode"
            @click.native="identifyCode = makeCode()"
          />
        </span>
      </template>
      <template v-else>
        赠送币数：
        <span>
          <el-input-number
            placeholder="币数"
            v-model="moneyGive"
            controls-position="right"
            :min="0"
            :max="999999"
            size="small"
            style="margin-right:20px;width: 120px"
          ></el-input-number>
        </span>
        赠送说明：
        <span style="margin-right:20px">
          <el-input
            size="small"
            v-model="detail"
            placeholder="请输入内容"
          ></el-input>
        </span>
        验证码：
        <span>
          <el-input
            size="small"
            v-model="mycode"
            placeholder="请输入验证码"
            style="margin-right:20px;width: 120px"
          ></el-input>
        </span>
        <identify
          :identifyCode.sync="identifyCode"
          @click.native="identifyCode = makeCode()"
        />
      </template>
      <span style="margin-left: auto">
        <el-button
          style="margin-left: 32px"
          size="small"
          type="primary"
          @click="getChargeAndGive()"
        >{{myradio}}</el-button>
      </span>
    </div>
    <div class="renewal__content">
      <el-table
        :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
        border
        stripe
        height="100%"
        max-height="100%"
        style="min-width: 100%"
        size="mini"
        ref="table"
      >
        <el-table-column
          v-for="(item, index) in columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          align="center"
          :fixed="item.fixed"
        />
        <!-- <el-table-column
          fixed="right"
          label="操作"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="getIllegalDetail(scope.row)"
            >续费</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
    </div>
  </div>
</template>
<script>
import UserSelect from "@/components/UserSelect/index.vue";
import identify from "@/components/Identify/index.vue";

let columns1 = [
  { prop: "index", label: "序号", width: 50, type: 0, fixed: true },
  {
    prop: "chargeCount",
    label: "数量",
    width: 80,
    type: 0,
    fixed: false
  },
  {
    prop: "createTime",
    label: "创建时间",
    width: 150,
    type: 0,
    fixed: false
  },
  { prop: "money", label: "充值币", width: 100, type: 0, fixed: false },
  {
    prop: "moneyAfter",
    label: "充值后币数",
    width: 100,
    type: 0,
    fixed: false
  },
  {
    prop: "moneyBefore",
    label: "充值前币数",
    width: 150,
    type: 0,
    fixed: false
  },
  {
    prop: "operName",
    label: "操作人",
    width: 80,
    type: 0,
    fixed: false
  },
  {
    prop: "price",
    label: "价钱",
    width: 80,
    type: 0,
    fixed: false
  },
  {
    prop: "rate",
    label: "利率",
    width: 80,
    type: 0,
    fixed: false
  },
  {
    prop: "rmb",
    label: "充值的RMB",
    width: 100,
    type: 0,
    fixed: false
  },
  {
    prop: "userA",
    label: "充值方账号",
    width: 100,
    type: 0,
    fixed: false
  },
  {
    prop: "userB",
    label: "接受充值方账号",
    width: 120,
    type: 0,
    fixed: false
  },
  {
    prop: "years",
    label: "年限",
    width: 80,
    type: 0,
    fixed: false
  }
];

let columns2 = [
  { prop: "index", label: "序号", width: 50, type: 0, fixed: true },
  {
    prop: "chargeCount",
    label: "数量",
    width: 80,
    type: 0,
    fixed: false
  },
  {
    prop: "createTime",
    label: "创建时间",
    width: 150,
    type: 0,
    fixed: false
  },
  { prop: "money", label: "充值币", width: 100, type: 0, fixed: false },
  {
    prop: "moneyAfter",
    label: "赠送后币数",
    width: 100,
    type: 0,
    fixed: false
  },
  {
    prop: "moneyBefore",
    label: "赠送前币数",
    width: 150,
    type: 0,
    fixed: false
  },
  {
    prop: "moneyGive",
    label: "赠送的币数",
    width: 100,
    type: 0,
    fixed: false
  },
  {
    prop: "operName",
    label: "操作人",
    width: 80,
    type: 0,
    fixed: false
  },
  // {
  //   prop: "price",
  //   label: "价钱",
  //   width: 80,
  //   type: 0,
  //   fixed: false
  // },
  // {
  //   prop: "rate",
  //   label: "利率",
  //   width: 80,
  //   type: 0,
  //   fixed: false
  // },
  // {
  //   prop: "rmb",
  //   label: "充值的RMB",
  //   width: 100,
  //   type: 0,
  //   fixed: false
  // },
  {
    prop: "userA",
    label: "赠送方账号",
    width: 100,
    type: 0,
    fixed: false
  },
  {
    prop: "userB",
    label: "接受赠送方账号",
    width: 120,
    type: 0,
    fixed: false
  },
  {
    prop: "years",
    label: "年限",
    width: 80,
    type: 0,
    fixed: false
  },
  {
    prop: "remark",
    label: "赠送说明",
    width: 80,
    type: 0,
    fixed: false
  }
];

export default {
  components: {
    UserSelect,
    identify
  },
  data() {
    return {
      identifyCode: this.makeCode(),
      coins: 1,
      cars: 1,
      years: 1,
      detail: "",
      moneyGive: 1,
      mycode: "",
      myradio: "充值",
      currentPage: 1,
      pageSize: 100,
      total: 0,
      tableData: [],
      data1: [],
      data2: [],
      searchValue: null,
      columns: columns1
    };
  },
  mounted() {},

  computed: {},
  watch: {
    myradio: {
      handler(val) {
        if (val === "充值") {
          this.columns = columns1;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
          });
          this.tableData = this.data1;
        } else {
          this.columns = columns2;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
          });
          this.tableData = this.data2;
        }
        this.clear();
      },
      immediate: true
    }
  },
  methods: {
    clear() {
      this.identifyCode = this.makeCode();
      this.mycode = "";
      this.coins = 1;
      this.cars = 1;
      this.years = 1;
      this.detail = "";
      this.moneyGive = 1;
    },
    makeCode() {
      const codes = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(
        ""
      );
      return new Array(4)
        .fill("")
        .map(() => {
          const i = randomNum(0, codes.length);
          return codes[i];
        })
        .join("");

      function randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      }
    },
    async getChargeAndGive() {
      if (this.searchValue === null) {
        this.$msg({
          showClose: true,
          message: "用户名为空！",
          type: "error"
        });
        return;
      }
      if (this.mycode.toLowerCase() != this.identifyCode.toLowerCase()) {
        this.$msg({
          showClose: true,
          message: "验证码错误！",
          type: "error"
        });
        this.identifyCode = this.makeCode();
        return;
      }
      try {
        const { data, msg, total } = await this.$API.getChargeAndGive({
          chargeCount: this.cars,
          moneyGive: this.moneyGive,
          price: this.coins,
          remark: this.detail,
          type: this.myradio === "充值" ? 1 : 2,
          years: this.years,
          userId: (this.searchValue && this.searchValue.id) || ""
        });
        if (this.myradio === "充值") {
          this.data1 = [data].map((item, index) => ({
            ...item,
            index: (this.currentPage - 1) * this.pageSize + index + 1
          }));
          this.tableData = this.data1;
        } else {
          this.data2 = [data].map((item, index) => ({
            ...item,
            index: (this.currentPage - 1) * this.pageSize + index + 1
          }));
          this.tableData = this.data2;
        }
        this.total = total;
        this.$msg({
          showClose: true,
          message: msg,
          type: "success"
        });
        this.clear();
        this.$emit("update");
      } catch (error) {
        console.log(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.renewal {
  overflow: hidden;
  height: calc(100vh - 200px);
  display: flex;
  position: relative;
  &__header {
    position: absolute;
    top: 30px;
    display: flex;
    align-items: center;
    height: 60px;
    width: 100%;
    white-space: nowrap;
    & > span {
      height: 40px;
      display: flex;
      align-items: center;
      white-space: nowrap;
      padding: 0 5px;
    }
    .btnOptions {
      .el-button + .el-button {
        margin-left: 1px;
      }
      .el-button:nth-child(1) {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      .el-button:nth-child(3) {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
  .counts {
    height: 40px;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
  }
  &__content {
    width: 100%;
    position: absolute;
    top: 90px;
    height: calc(100vh - 340px);
    transition: all 0.2s;
  }
}
</style>